// JsFromRoutes CacheKey e1dd8e9446cbd1358ae7e6c0afe2ec0c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  stripeCustomerPortal: /* #__PURE__ */ definePathHelper('post', '/employers/invoices/stripe_customer_portal'),
  index: /* #__PURE__ */ definePathHelper('get', '/employers/invoices'),
  show: /* #__PURE__ */ definePathHelper('get', '/employers/invoices/:id'),
  showPlatformFee: /* #__PURE__ */ definePathHelper('get', '/employers/invoices/platform_fees/:id'),
}
